import { restApiClient } from '@/datasources';
import { Appointment } from '@/types/appointments.types';
import { getLogger } from '@/logger/logger';

const logger = getLogger('appointments.get-by-id');

export async function getAppointmentById(id: string): Promise<Appointment | null> {
  try {
    const { data: appointment } = await restApiClient.get<Appointment>(`/online/customers/appointments/${id}/`);

    return appointment;
  } catch (error) {
    logger.error('Failed to fetch the appointment', {
      appointment: { event: 'fetch_failed', appointment_id: id },
      error,
    });

    return null;
  }
}
